<template>
    <div class="pay-record">
        <base-header :head_id="head_id" :name="name" :account_list="account_list"></base-header>
        <base-title :title="`充值/消费记录`"></base-title>
        <div class="record-box">
            <base-radio :list="arr" :val="type" @choose="changeType" :is_larger="`true`"></base-radio>
            <div class="log-wrapper" style="overflow-x:hidden">
                <ul class="list" v-infinite-scroll="load" infinite-scroll-disabled="disabled">
                    <li v-for="(item, index) in data_list" class="list-item" :key = "index">
                        <div :class="`money ${type==2&&item.money1?'money2':''}`">
                                {{type == 1? `+${item.count}酒币` : `-${item.money1? (item.money1 + '酒币'): (item.money2 + '酒豆')}`}}</div>
                        <div class="msg">
                            <p class="time">{{item.create_time}}</p>
                            <p class="source">{{type==1? item.channel : item.app_name}}</p>
                        </div>
                        <el-divider class="divider"></el-divider>
                    </li>
                </ul>
                <p v-if="loading">加载中...</p>
                <p v-if="noMore">没有更多了</p>
            </div>
        </div>
        <div class="toast">仅展示近3个月充值/消费记录</div>
    </div>
</template>
<script>
export default {
    name: 'pay-record',
    data() {
        return {
            data_list: [],
            start: 0,
            loading: false,
            type: 1,
            arr: [
                { value: 1, name: '充值记录' },
                { value: 2, name: '消费记录' },
            ],
            is_read: true,
            val: '',
            activeNames: ['1'],
            head_id: this.$storage.getHeadId(),
            name: this.$storage.getUserName(),
            square_icon: require('@/assets/img/square.png'),
            isActive: false,
            token: this.$storage.getAuth(),
            total: 0,
            total2: 0,
            page_num: 10,
            account_list: JSON.parse(this.$storage.getAccountList()),
            is_first: true,
        }
    },
    computed: {
        noMore() {
            return this.start >= (this.type == 1 ? this.total : this.type == 2 ? this.total2 : 0);
        },
        disabled() {
            return this.loading || this.noMore
        },
    },
    created() {
        this.init_total()
        this.changeType(1)
    },
    methods: {
        load() {
            console.log('loading');
            this.loading = true
            setTimeout(()=>{
                this.start += this.page_num;
                this.get_data(this.type);
            }, 1000)
        },
        handleChange(val) {
            console.log(val)
        },
        switch_account(val) {
            this.$message.success(val)
        },
        init_total(){
            this.$http.q_my_charge(90, this.token).then((res) => {
                if (res.code == 0) {
                    this.total = res.count;
                } else {
                    this.total = 0;
                }
            })
            this.$http.q_my_sub(90, this.token).then((res) => {
                if (res.code == 0) {
                    this.total2 = res.count;
                } else {
                    this.total2 = 0;
                }
            })
        },
        // 切换记录  1充值 2消费
        changeType(val) {
            if(!this.is_first && val == this.type){
                return false
            }
            this.is_first = false;
            this.data_list = [];
            this.start = 0;
            this.type = val;
            this.get_data(val);
        },

        get_data(val){
            if(val == 1){
                this.$http.q_my_charge(90, this.token, this.start, this.page_num).then((res) => {
                    if (res.code == 0) {
                        this.data_list = this.data_list.concat(res.records);
                    }
                    this.loading = false
                })
            } else {
                this.$http.q_my_sub(90, this.token, this.start, this.page_num).then((res) => {
                    if (res.code == 0) {
                        this.data_list = this.data_list.concat(res.records);
                    }
                    this.loading = false
                })
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.pay-record {
    width: 100%;
    height: 100%;
    .record-box {
        width: 92%;
        height: calc(100vh - 5.8rem);
        background: #ffffff;
        border-radius: 0.2rem;
        margin: 0 auto;
        padding-top: 0.26rem;
        .radio-box {
            margin-bottom: 0.26rem;
        }
        .log-wrapper{
            position: relative;
            width: 94%;
            height: calc(100% - 1.3rem);
            padding: 0 3%;
            margin: 0 auto;
            p{
                font-size: .22rem;
                color: #919191;
                text-align: center;
                width: 100%;
                height: .3rem;
                line-height: .3rem;
            }
            .list{
                min-height: 40%;
                .list-item{
                    width: 100%;
                    height: 1.5rem;
                    .divider{
                        margin: 0;
                    }
                    .money{
                        color: #C39B5E;
                        font-size: .32rem;
                        height: .26rem;
                        line-height: .26rem;
                        display: block;
                        // margin-top: .34rem;
                        &.money2{
                            color: #00A2FF;
                        }
                    }
                    .msg{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin: .36rem 0 .32rem 0 ;
                        p{
                            text-align: left;
                            display: inline-block;
                            color: #919191;
                            font-size: .22rem;
                             height: .21rem;
                            line-height: .21rem;
                            &.source{
                                text-align: right;
                            }
                        }
                    }
                }
            }
        }

    }
    .toast{
        position: absolute;
        bottom: .41rem;
        left: 0;
        font-size: .22rem;
        color: #919191;
        text-align: center;
        width: 100%;
        height: .22rem;
        line-height: .22rem;
    }
}
</style>




// WEBPACK FOOTER //
// src/view/pay_record.vue